// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NavTopBarHeader-base__rcOdL{position:relative;z-index:var(--z-index-base);display:flex;align-items:center;justify-content:space-between;height:calc(var(--size-15) + var(--size-0_25));padding:var(--size-0) var(--size-4);background-color:var(--surface-level-first);border-bottom:var(--size-0_25) solid var(--gray-a4)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "NavTopBarHeader-base__rcOdL"
};
export default ___CSS_LOADER_EXPORT___;
